import { AuthUser } from '@/models/AuthModels';
import { MutationTree } from 'vuex';
import { State } from './state';

import { LoginConfig } from '@/models/AuthModels';
import { ApiKey, CreateApiKeyResponse } from '@/models/ApiKeyModels';

export enum MutationTypes {
  LoginSuccess = 'LOGINSUCCESS',
  RefreshLoginSuccess = 'REFRESHLOGINSUCCESS',
  Logout = 'LOGOUT',
  SetLoginConfig = 'SETLOGINCONFIG',

  SetApiKeys = 'SETAPIKEYS',
  UpsertApiKey = 'UPSERTAPIKEY',
  RemoveApiKey = 'REMOVEAPIKEY',
  SetCreatedApiKey = 'SETCREATEDAPIKEY',
  ResetCreatedApiKey = 'RESETCREATEDAPIKEY',
}

export type Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.Logout](state: State): void;
  [MutationTypes.SetLoginConfig](state: State, config: LoginConfig): void;

  [MutationTypes.SetApiKeys](state: State, apiKeys: Array<ApiKey>): void;
  [MutationTypes.UpsertApiKey](state: State, apiKey: ApiKey): void;
  [MutationTypes.RemoveApiKey](state: State, id: number): void;
  [MutationTypes.SetCreatedApiKey](state: State, createdApiKey: CreateApiKeyResponse): void;
  [MutationTypes.ResetCreatedApiKey](state: State): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;
    state.loggedIn = true;

    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;
    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.Logout](state: State) {
    state.loggedIn = false;
    state.authUser = null;
    localStorage.removeItem('authUser');
  },

  [MutationTypes.SetLoginConfig](state: State, config: LoginConfig) {
    state.loginConfig = config;
    localStorage.setItem('loginConfig', JSON.stringify(config));
  },

  [MutationTypes.SetApiKeys](state: State, apiKeys: Array<ApiKey>) {
    state.apiKeys = apiKeys;
  },

  [MutationTypes.UpsertApiKey](state: State, apiKey: ApiKey) {
    const index = state.apiKeys.findIndex((k) => k.id === apiKey.id);
    if (index !== -1) {
      state.apiKeys.splice(index, 1, apiKey);
    } else {
      state.apiKeys.push(apiKey);
    }
  },

  [MutationTypes.RemoveApiKey](state: State, id: number) {
    const index = state.apiKeys.findIndex((k) => k.id === id);
    if (index !== -1) {
      state.apiKeys.splice(index, 1);
    }
  },

  [MutationTypes.SetCreatedApiKey](state: State, createdApiKey: CreateApiKeyResponse) {
    state.createdApiKey = createdApiKey;
  },

  [MutationTypes.ResetCreatedApiKey](state: State) {
    state.createdApiKey = null;
  },
};
